<template>
  <div style="text-align:right;line-height:30px;margin-right:119px;">
    <p>
      {{$t('txmis.rebateComponents.subtotal')}}：{{$t('txmis.rewardDealList.currentRebete')}}<span>{{sub}}</span>
    </p>
    <p>
      {{$t('txmis.rebateComponents.total')}}：{{$t('txmis.rewardDealList.currentRebete')}}<span>{{totalize}}</span>
    </p>
  </div>
</template>

<script>
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    export default {
        props: ["tableData", 'totalize'],
        data() {
            return {
            };
        },
        computed: {
            sub: {
                //currentRebete
                get() {
                    let amount = 0;
                    if (!this.tableData || this.tableData.length == 0) return amount;
                    this.tableData.forEach((item, index) => {
                        amount = DateUtil.accAdd(amount, item.currentRebete);
                    });
                    return amount;
                }
            },
        },
        methods: {
        },
        mounted() {
        }
    };
</script>
